export default {
  ExpenseRegular: 1, // thu đẻ chi thường xuyên
  ExpenseInvestXDCB: 2, // thu để chi đầu tư XDCB
};